import React, { Fragment, ReactNode } from 'react';
import styles from './styles.module.css';

interface item {
  id?: number;
  title?: string;
  value?: string | number | ReactNode;
}
export default function ProductAttributes({
  data,
  className = '',
  children,
}: {
  data?: item[];
  className?: string;
  children?: ReactNode;
}) {
  return (
    <table className={`${styles.spec_table} ${className}`}>
      {children}
      <tbody>
        {data?.map((item, index) => (
          <Fragment key={index}>
            {item?.value != 'displayNone' && (
              <tr key={item?.id}>
                <td>{item?.title}</td>
                <td>{item?.value}</td>
              </tr>
            )}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
}
